function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcons8Achtung100 = function SvgIcons8Achtung100(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 92 92",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M50,4A46,46,0,1,0,96,50,46,46,0,0,0,50,4Zm0,4A42,42,0,1,1,8,50,42,42,0,0,1,50,8ZM47.6,28.6a.73.73,0,0,0-.8.8v27a.73.73,0,0,0,.8.8h4.6a.73.73,0,0,0,.8-.8v-27a.73.73,0,0,0-.8-.8Zm0,36a.73.73,0,0,0-.8.8v5.2a.73.73,0,0,0,.8.8h4.8a.73.73,0,0,0,.8-.8V65.4a.73.73,0,0,0-.8-.8Z",
    transform: "translate(-4 -4)",
    style: {
      fill: "#387bf5"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcons8Achtung100, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icons8-achtung-100.60e96f1b.svg";
export { ForwardRef as ReactComponent };